import sendBeaconEventDispatcher from './event_processor/event_dispatcher/send_beacon_dispatcher.browser';
import { getOptimizelyInstance } from './client_factory';
import { JAVASCRIPT_CLIENT_ENGINE } from './utils/enums';
import { BrowserRequestHandler } from './utils/http_request_handler/request_handler.browser';
/**
 * Creates an instance of the Optimizely class
 * @param  {Config} config
 * @return {Client|null} the Optimizely client object
 *                           null on error
 */
export const createInstance = function (config) {
    const client = getOptimizelyInstance(Object.assign(Object.assign({}, config), { requestHandler: new BrowserRequestHandler() }));
    if (client) {
        const unloadEvent = 'onpagehide' in window ? 'pagehide' : 'unload';
        window.addEventListener(unloadEvent, () => {
            client.flushImmediately();
        });
    }
    return client;
};
export const getSendBeaconEventDispatcher = () => {
    return sendBeaconEventDispatcher;
};
export { default as eventDispatcher } from './event_processor/event_dispatcher/default_dispatcher.browser';
export { createPollingProjectConfigManager } from './project_config/config_manager_factory.browser';
export { createForwardingEventProcessor, createBatchEventProcessor } from './event_processor/event_processor_factory.browser';
export { createOdpManager } from './odp/odp_manager_factory.browser';
export { createVuidManager } from './vuid/vuid_manager_factory.browser';
export * from './common_exports';
export * from './export_types';
export const clientEngine = JAVASCRIPT_CLIENT_ENGINE;
export const __platforms = ['browser'];
//# sourceMappingURL=index.browser.js.map